import { render, staticRenderFns } from "./IVPlayer.vue?vue&type=template&id=471a9272"
import script from "./IVPlayer.vue?vue&type=script&lang=js"
export * from "./IVPlayer.vue?vue&type=script&lang=js"
import style0 from "./IVPlayer.vue?vue&type=style&index=0&id=471a9272&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports